import React, { Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './ProficiencyTagRanking.scss';

const questionKeyToTagType = (key) => {
  const arr = key.replace('_ranking', '').replace(/_/g, ' ').split('');
  const firstLetter = arr.shift();
  return [firstLetter.toUpperCase()].concat(arr);
};

const sortTags = (tags) => {
  const ranked = [];
  const unranked = [];

  tags.forEach((tag) => {
    if (tag.ranking) {
      ranked.push(tag);
    } else {
      unranked.push(tag);
    }
  });

  ranked.sort((tagA, tagB) => tagA.ranking - tagB.ranking);

  return { ranked, unranked };
};

class ProficiencyTagRanking extends React.Component {
  constructor(props) {
    super(props);

    const sortedTags = sortTags(props.answer);

    this.state = {
      rankedTags: sortedTags.ranked,
      unrankedTags: sortedTags.unranked,
    };

    this.tagType = questionKeyToTagType(props.questionKey);
    this.handleTagsUpdated = this.handleTagsUpdated.bind(this);
    this.handlePromote = this.handlePromote.bind(this);
    this.handleDemote = this.handleDemote.bind(this);
  }

  handleTagsUpdated() {
    const { handleChange, questionKey } = this.props;
    const { rankedTags, unrankedTags } = this.state;

    handleChange(questionKey, rankedTags, unrankedTags);
  }

  handlePromote(existingTag) {
    const { rankedTags } = this.state;
    const { unrankedTags } = this.state;

    return () => {
      const tag = { ...existingTag };
      if (tag.ranking === 1) return;
      if (tag.ranking) {
        tag.ranking -= 1;
        const swapTag = { ...rankedTags.find((t) => t.ranking === tag.ranking) };
        swapTag.ranking += 1;
        this.setState({
          rankedTags: rankedTags.map((t) => {
            if (t.value === tag.value) { return tag; }
            if (t.value === swapTag.value) { return swapTag; }
            return t;
          }).sort((a, b) => a.ranking - b.ranking),
        }, this.handleTagsUpdated);
      } else if (rankedTags.length >= 3) {
        const lowestRankedTag = rankedTags.pop();
        lowestRankedTag.ranking = null;
        tag.ranking = 3;
        this.setState({
          rankedTags: rankedTags.concat([tag]),
          unrankedTags: unrankedTags.filter((t) => t.value !== tag.value).concat([lowestRankedTag]),
        }, this.handleTagsUpdated);
      } else {
        tag.ranking = rankedTags.length + 1;
        this.setState({
          rankedTags: rankedTags.concat([tag]),
          unrankedTags: unrankedTags.filter((t) => t.value !== tag.value),
        }, this.handleTagsUpdated);
      }
    };
  }

  handleDemote(existingTag) {
    const { rankedTags } = this.state;
    const { unrankedTags } = this.state;

    return () => {
      const tag = { ...existingTag };
      if (!tag.ranking) return;
      tag.ranking = null;
      this.setState({
        rankedTags: rankedTags.filter((t) => t.value !== tag.value),
        unrankedTags: [tag].concat(unrankedTags),
      }, this.handleTagsUpdated);
    };
  }

  renderTag(tag) {
    const clickAction = tag.ranking ? this.handleDemote(tag) : this.handlePromote(tag);

    return (
      <Row
        className={`proficiency-ranking-tag tag-label ${tag.ranking ? 'ranked' : ''}`}
        id={`rankable-${tag.value}`}
        onClick={clickAction}
        role="button"
        tabIndex={0}
      >
        <Col xs={1} className="ranked-tag-icon">
          {tag.ranking && <i className="fas fa-check" />}
        </Col>
        <Col xs={11}>{tag.label}</Col>
      </Row>
    );
  }

  renderTagsList(tags) {
    return (
      <Fragment>
        {tags.map((tag) => this.renderTag(tag))}
      </Fragment>
    );
  }

  render() {
    const { rankedTags, unrankedTags } = this.state;

    return (
      <Fragment>
        <div className="body-text-2 demibold mb-12">
          {this.tagType}
          :
        </div>
        <div className="proficiency-tag-ranking-container style-guide">
          {this.renderTagsList(rankedTags)}
          {this.renderTagsList(unrankedTags)}
        </div>
      </Fragment>
    );
  }
}

ProficiencyTagRanking.propTypes = {
  answer: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  questionKey: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default ProficiencyTagRanking;
